// Lazy Supabase client initialization wrapper
// This ensures the client is only created when actually needed

import { createClient, SupabaseClient } from '@supabase/supabase-js';
import type { Database } from '@/integrations/supabase/types';

// Fallback values from Lovable Cloud configuration
const FALLBACK_URL = 'https://ydwqhnwvmsghmfdbgwub.supabase.co';
const FALLBACK_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inlkd3Fobnd2bXNnaG1mZGJnd3ViIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQ2ODY4MTcsImV4cCI6MjA4MDI2MjgxN30.t3LualaEpZI8bIFGSMMbZQTZAdGftQ5xgp2Gy4ENCqU';

let supabaseInstance: SupabaseClient<Database> | null = null;

export function getSupabase(): SupabaseClient<Database> {
  if (supabaseInstance) {
    return supabaseInstance;
  }

  // Try to get from environment, fall back to hardcoded values
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || FALLBACK_URL;
  const supabaseKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || FALLBACK_KEY;

  supabaseInstance = createClient<Database>(supabaseUrl, supabaseKey, {
    auth: {
      storage: localStorage,
      persistSession: true,
      autoRefreshToken: true,
    }
  });

  return supabaseInstance;
}

// For components that need synchronous access
export const supabase = new Proxy({} as SupabaseClient<Database>, {
  get(_, prop) {
    return getSupabase()[prop as keyof SupabaseClient<Database>];
  }
});
